import PropTypes from 'prop-types'
import './Avatar.css'

const initialsOf = (name) => {
  const parts = String(name || '').trim().split(/\s+/)
  return ((parts[0]?.[0] || '') + (parts[parts.length - 1]?.[0] || '')).toUpperCase()
}

/* Initials avatar tinted by gender — the leading visual for people rows. */
const Avatar = ({ name, gender, large = false }) => (
  <span
    className={`mc-avatar mc-avatar-${gender || 'unknown'} ${large ? 'mc-avatar-lg' : ''}`}
    aria-hidden="true"
  >
    {initialsOf(name)}
  </span>
)

Avatar.propTypes = {
  name: PropTypes.string.isRequired,
  gender: PropTypes.string,
  large: PropTypes.bool,
}

export default Avatar
